// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13h5j","top":"styles_top__1tUar","left":"styles_left__DWSzE","description":"styles_description__3Ln1M"};